const tableTypes = {
  employeesList: "employeesList",
  organizationList: "organizationList",
  payslip: "payslip",
  leaves: "leaves",
  resignation: "resignation",
};

export default tableTypes;
